<template>
  <div class="bg-gray-100">
    <div class="container mx-auto p-6 pt-12 text-center">
      <h1 class="text-2xl font-bold mb-4">Cookie Policy</h1>
      <p class="text-lg">Informazioni sui cookie utilizzati dal sito</p>
    </div>
    <!-- Main Content -->
    <main class="container mx-auto p-6 pb-12">
      <section class="bg-white shadow-md rounded-lg p-6 mb-8">
        <p class="mb-4 text-sm">
          La presente Cookie Policy descrive l'uso dei cookie nel sito web <a href="https://www.associazionetau.it" class="text-blue-500">www.associazionetau.it</a> (di seguito, il "Sito") gestito da Associazione Tau APS (di seguito, "noi", "nostro/a").
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-3">1. Cosa sono i cookie?</h3>
        <p class="mb-4 text-sm">
          I cookie sono piccoli file di testo che vengono inviati dal Sito al dispositivo dell'utente durante la navigazione. Questi file vengono memorizzati nel browser per permettere al Sito di riconoscere l'utente in future visite e per raccogliere informazioni anonime sulle sue attività di navigazione.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-3">2. Tipologie di cookie utilizzati</h3>
        <p class="mb-4 text-sm">
          Sul nostro Sito utilizziamo i seguenti tipi di cookie:
        </p>
        <ul class="list-disc pl-6 mb-4 text-sm">
          <li><strong>Cookie tecnici:</strong> Questi cookie sono necessari per il funzionamento del Sito e non possono essere disabilitati nei nostri sistemi. Di solito sono impostati solo in risposta a azioni effettuate dall'utente, come la selezione delle preferenze o l'accesso a contenuti protetti.</li>
          <li><strong>Cookie analitici:</strong> Utilizziamo Google Analytics per raccogliere informazioni anonime sulla navigazione degli utenti, come il numero di visitatori, la durata della visita e le pagine visualizzate. Questi dati ci aiutano a migliorare le prestazioni del Sito.</li>
          <li><strong>Cookie di profilazione e di marketing:</strong> Microsoft Clarity e altri strumenti simili possono essere utilizzati per raccogliere informazioni sulle modalità di interazione degli utenti con il nostro Sito per ottimizzare l'esperienza e i contenuti pubblicitari.</li>
        </ul>

        <h3 class="text-xl font-semibold mt-6 mb-3">3. Come disabilitare i cookie</h3>
        <p class="mb-4 text-sm">
          Puoi gestire le preferenze relative ai cookie direttamente dalle impostazioni del tuo browser. La maggior parte dei browser ti consente di rifiutare o accettare i cookie, oppure di ricevere una notifica quando vengono inviati. Tuttavia, disabilitare i cookie potrebbe influire sulle funzionalità del Sito.
        </p>
        <p class="mb-4 text-sm">
          Ecco alcuni link che ti possono aiutare a disabilitare i cookie nei principali browser:
        </p>
        <ul class="list-disc pl-6 mb-4 text-sm">
          <li><a href="https://support.google.com/chrome/answer/95647?hl=it" target="_blank" class="text-blue-500">Chrome</a></li>
          <li><a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank" class="text-blue-500">Firefox</a></li>
          <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" class="text-blue-500">Safari</a></li>
          <li><a href="https://www.microsoft.com/it-it/edge/features/privacy" target="_blank" class="text-blue-500">Edge</a></li>
        </ul>

        <h3 class="text-xl font-semibold mt-6 mb-3">4. Come utilizziamo i cookie</h3>
        <p class="mb-4 text-sm">
          I cookie ci aiutano a migliorare l'esperienza di navigazione degli utenti, a raccogliere informazioni statistiche in forma anonima, e a personalizzare i contenuti e la pubblicità che mostriamo. In particolare, i cookie analitici ci permettono di capire come il nostro sito viene utilizzato e di migliorarlo continuamente.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-3">5. Consenso all'uso dei cookie</h3>
        <p class="mb-4 text-sm">
          Quando accedi al nostro Sito, ti chiediamo di accettare l'uso dei cookie tramite un banner che appare all'inizio della visita. Se accetti, i cookie vengono memorizzati nel tuo dispositivo. Puoi comunque modificare le tue preferenze in qualsiasi momento.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-3">6. Modifiche alla Cookie Policy</h3>
        <p class="mb-4 text-sm">
          Ci riserviamo il diritto di aggiornare questa Cookie Policy in qualsiasi momento, in conformità con le modifiche alle leggi o alle nostre pratiche aziendali. Ogni aggiornamento sarà pubblicato su questa pagina con una data di aggiornamento riportata all'inizio.
        </p>

        <h3 class="text-xl font-semibold mt-6 mb-3">7. Contatti</h3>
        <p class="mb-4 text-sm">
          Per qualsiasi domanda riguardo a questa Cookie Policy o sull'uso dei cookie, puoi contattarci via email all'indirizzo: <a href="mailto:associazionetau@virgilio.it" class="text-blue-500">associazionetau@virgilio.it</a>.
        </p>
      </section>
    </main>
  </div>
</template>

<script lang="ts" setup>

</script>

<style>

</style>